import _ from 'lodash'
import { index as getLanguagesService } from '@/services/app/getLanguages'
import { getNotificationsStatus } from '@/services/app/getNotificationsStatus'
import { getNotificationsType } from '@/services/app/getNotificationsType'
import { companies } from '@/services/app/getCompanies'
import { unlinkCertificate } from '@/services/certificates/unlinkCertificate'
import { getAnnouncements } from '@/services/app/getAnnouncements'
import { getColumnsVistas } from '@/services/grids/getColumnsVistas'
import { getColors } from '@/services/app/getColors'
import { TIPOS_NEO } from '@/config/tipos-neo'

const state = () => ({
  version: process.env.VUE_APP_VERSION,
  darkMode: false,
  loading: false,
  selectedLang: null,
  showPrimaryMenu: true,
  navFromMenu: false,
  feedback: {
    showing: false,
    data: {}
  },
  errors: [],
  relatedBusinesses: [],
  headerCore: {
    companyId: null,
    businessId: null
  },
  queryHeaders: {
    companyId: null,
    businessId: null
  },
  languages: [],
  AllCifs: [],
  Empresas: [],
  NotificationsStatus: [],
  NotificationsTypes: [],
  gettingCifs: false,
  gettingEmpresas: false,
  gettingNotifsStatus: false,
  gettingNotifsTypes: false,
  gettingAnnouncements: false,
  isAdmin: false,
  unlinkingCert: false,
  AnnouncementsList: null,
  headerBreadCrumb: null,
  actualRoute: null,
  actualRoutePublic: true,
  fromRouteName: null,
  isLower1024: false,
  // Filter nav
  idClienteFilterNav: null,
  idClienteFilterAlerts: null,
  // Searches
  tiposServicio: [],
  tiposPartners: [],
  tiposGruposVigilantes: [],
  tiposNotificacion: TIPOS_NEO,
  // Control zonas abiertas
  openTrash: false,
  // Otros
  lastVisitedPatchNotes: 'v.1.0.0',
  controlFlagLicense: false,
  controlFlagWizard: false,
  autoIdleTime: false,
  alertsTimeExtended: false,
  // Cambios formularios sin guardar
  formChanges: false,
  showModalConfirmChanges: false,
  lastRouteComplete: null,
  // Colores
  colors: null,
  // Chatbot
  showButtonChatbot: false,  
  // SIN USO
  tourFirstStepsActive: false,
})

const getters = {
  showButtonChatbot: state => state.showButtonChatbot,
  formChanges: state => state.formChanges,
  showModalConfirmChanges: state => state.showModalConfirmChanges,
  lastRouteComplete: state => state.lastRouteComplete,
  colors: state => state.colors,
  idClienteFilterNav: state => state.idClienteFilterNav,
  idClienteFilterAlerts: state => state.idClienteFilterAlerts,
  tourFirstStepsActive: state => state.tourFirstStepsActive,
  autoIdleTime: state => state.autoIdleTime,
  alertsTimeExtended: state => state.alertsTimeExtended,
  controlFlagLicense: state => state.controlFlagLicense,
  controlFlagWizard: state => state.controlFlagWizard,
  lastVisitedPatchNotes: state => state.lastVisitedPatchNotes,
  openTrash: state => state.openTrash,
  tiposServicio: state => state.tiposServicio,
  tiposPartners: state => state.tiposPartners,
  tiposGruposVigilantes: state => state.tiposGruposVigilantes,
  tiposNotificacion: state => state.tiposNotificacion,
  version: stat => stat.version,
  actualRoute: state => state.actualRoute,
  actualRoutePublic: state => state.actualRoutePublic,
  fromRouteName: state => state.fromRouteName,
  headerBreadCrumb: state => state.headerBreadCrumb,
  darkMode: state => state.darkMode,
  navFromMenu: state => state.navFromMenu,
  loading: state => state.loading,
  showPrimaryMenu: state => state.showPrimaryMenu,
  feedback: state => state.feedback.data,
  showingFeedback: state => state.feedback.showing,
  errors: state => state.errors,
  rfheaderCoreCompany: state => state.headerCore.companyId,
  ffheaderCoreBusiness: state => state.headerCore.businessId,
  rfqueryHeaders: state => state.queryHeaders,
  rfheaderCore: state => state.headerCore,
  languagesAvailables: state => {
    if (!_.isEmpty(state.languages.data)) {
      return _.map(state.languages.data, item => {
        return { code: item.code, name: item.name }
      })
    } else {
      return []
    }
  },
  selectedLang: state => state.selectedLang,
  businessesForSelect: (state) => {
    const data = []
    if (state.user) {
      const count = state.relatedBusinesses ? state.relatedBusinesses.length : 0
      for (let i = 0; i < count; i++) {
        const _temp = {}
        _temp.value = state.relatedBusinesses[i].id
        _temp.label = state.relatedBusinesses[i].name
        data.push(_temp)
      }
    }
    return data
  },
  gettingCifs: state => state.gettingCifs,
  allCifs: state => state.AllCifs,
  empresas: state => state.Empresas,
  isAdmin: state => state.isAdmin,
  notificationsStatusGroups: state => state.NotificationsStatus,
  notificationsStatus: state => {
    const statusActions = []
    state.NotificationsStatus.forEach(grupo => {
      grupo.Estados.forEach(estado => {
        if (estado.Notificaciones > 0) {
          statusActions.push(estado)
        }
      })
    })
    return statusActions
  },
  notificationsTypes: state => state.NotificationsTypes,
  actionsForSelect: (state, getters) => (id) => {
    if (id === undefined || id === null || id === 99999 || id === '99999') {
      const actions = getters.notificationsStatus
      return actions
    } else {
      const actions = getters.notificationsStatus.find(status => status.idEstado === id)
      return actions
    }
  },
  getAnnouncementsList: (state) => state.AnnouncementsList,
  getIsLower1024: (state) => {
    return state.isLower1024
  },
}

const mutations = {
  setshowButtonChatbot (state, value) {
    state.showButtonChatbot = value
  },
  setSelectedLang (state, value) {
    state.selectedLang = value
  },
  setFormChanges (state, value) {
    state.formChanges = value
  },
  setShowModalConfirmChanges (state, value) {
    state.showModalConfirmChanges = value
  },
  setLastRouteComplete (state, value) {
    state.lastRouteComplete = value
  },
  setColors (state, value) {
    state.colors = value
  },
  resetColors (state) {
    state.colors = null
  },
  setidClienteFilterAlerts (state, value) {
    state.idClienteFilterAlerts = value
  },
  setidClienteFilterNav (state, value) {
    state.idClienteFilterNav = value
  },
  settourFirstStepsActive (state, value) {
    state.tourFirstStepsActive = value
  },
  setautoIdleTime (state, value) {
    state.autoIdleTime = value
  },
  setalertsTimeExtended (state, value) {
    state.alertsTimeExtended = value
  },
  setcontrolFlagLicense (state, value) {
    state.controlFlagLicense = value
  },
  setcontrolFlagWizard (state, value) {
    state.controlFlagWizard = value
  },
  setlastVisitedPatchNotes (state, value) {
    state.lastVisitedPatchNotes = value
  },
  setVersion (state, value) {
    state.version = value
  },
  setopenTrash (state, value) {
    state.openTrash = value
  },
  settiposServicio (state, tiposServicio) {
    state.tiposServicio = tiposServicio
  },
  settiposPartners (state, tiposPartners) {
    state.tiposPartners = tiposPartners
  },
  settiposGruposVigilantes (state, tiposGruposVigilantes) {
    state.tiposGruposVigilantes = tiposGruposVigilantes
  },
  // settiposNotif (state, tiposNotif) {
  //   state.tiposNotif = tiposNotif
  // },
  setIsLower1024 (state, isLower1024) {
    state.isLower1024 = isLower1024
  },
  setfromRouteName (state, value) {
    state.fromRouteName = value
  },
  setActualRoute (state, value) {
    state.actualRoute = value
  },
  setActualRoutePublic (state, value) {
    state.actualRoutePublic = value
  },
  setheaderBreadCrumb (state, value) {
    state.headerBreadCrumb = value
  },
  setDarkMode (state, value) {
    state.darkMode = value

    if (value === false) {
      document.body.classList.remove('dark')
    } else {
      document.body.classList.add('dark')
    }
  },
  setRelatedBusiness (state, data) {
    state.relatedBusinesses = data.data ? data.data : data
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setNavigationFromMenu (state, value) {
    state.navFromMenu = value
  },
  setShowPrimaryMenu (state, showPrimaryMenu) {
    state.showPrimaryMenu = showPrimaryMenu
  },
  setFeedback (state, feedback) {
    state.feedback.data = feedback
  },
  setShowingFeedback (state, showing) {
    state.feedback.showing = showing
  },
  setErrors (state, errors) {
    state.errors = errors
  },
  setError (state, error) {
    state.errors = [...state.errors, error]
  },
  clearErrors (state) {
    state.errors = []
  },
  setHeaderCoreCompany (state, companyId) {
    state.headerCore.companyId = companyId
  },
  setHeaderCoreBusiness (state, businessId) {
    state.headerCore.businessId = businessId
  },
  setHeadersQuery (state) {
    state.queryHeaders.businessId = state.headerCore.businessId
    state.queryHeaders.companyId = state.headerCore.companyId
  },
  resetHaderCoreFilters (state) {
    state.headerCore.businessId = null
    state.headerCore.companyId = null
    state.queryHeaders.businessId = state.headerCore.businessId
    state.queryHeaders.companyId = state.headerCore.companyId
  },
  setLanguages (state, data) {
    state.languages = data
  },
  setCifs (state, cifs) {
    state.AllCifs = cifs
  },
  auth_rol (state, isAdmin) {
    state.isAdmin = isAdmin
  },
  auth_request (state) {
    state.status = 'loading'
  },
  get_empresas_request (state) {
    state.gettingEmpresas = true
  },
  get_empresas_success (state, empresas) {
    state.Empresas = empresas
    state.gettingEmpresas = false
  },
  get_empresas_error (state) {
    state.gettingEmpresas = false
  },
  get_cifs_request (state) {
    state.gettingCifs = true
  },
  get_cifs_success (state, cifs) {
    state.AllCifs = cifs
    state.gettingCifs = false
  },
  get_cifs_error (state) {
    state.gettingCifs = false
  },
  unlink_cert_request (state) {
    state.unlinkingCert = true
  },
  unlink_cert_success (state, idCIFEmpresa) {
    state.unlinkingCert = false
    state.AllCifs = state.AllCifs.map(x => {
      if (x.IdCIFEmpresa === idCIFEmpresa) {
        x.Certificado = null
      }
      return x
    })
  },
  unlink_cert_error (state) {
    state.unlinkingCert = false
  },
  get_notifs_request (state) {
    state.gettingNotifsStatus = true
  },
  get_notifs_success (state, notifications) {
    state.NotificationsStatus = notifications
    state.gettingNotifsStatus = false
  },
  get_notifs_error (state) {
    state.gettingNotifsStatus = false
  },
  get_types_request (state) {
    state.gettingNotifsTypes = true
  },
  get_types_success (state, types) {
    state.NotificationsTypes = types
    state.gettingNotifsTypes = false
  },
  get_types_error (state) {
    state.gettingNotifsTypes = false
  },
  get_announcements_request (state) {
    state.gettingAnnouncements = true
  },
  get_announcements_success (state, announcements) {
    state.AnnouncementsList = announcements
    state.gettingAnnouncements = false
  },
  get_announcements_error (state) {
    state.gettingAnnouncements = false
  }
}

const actions = {
  async getColors ({ commit }) {
    const data = await getColors()
    if (data.blnError === true) {
      console.log(data.msgError + ' [Código de error: ' + data.codError + ']')
    } else {
      commit('setColors', data.Colores)
    }
  },
  async updateFrontColors ({ getters, dispatch }) {
    if (getters.colors && getters.colors.length > 0) {
      getters.colors.forEach(color => {
        document.querySelector(':root').style.setProperty(color.Clave, color.Color)
      })
    } else {
      await dispatch('resetColors')
    }
  }, 
  async resetColors ({ commit }) {
    document.querySelector(':root').style.setProperty('--primary-900', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-900'))
    document.querySelector(':root').style.setProperty('--primary-800', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-800'))
    document.querySelector(':root').style.setProperty('--primary-DEFAULT', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-DEFAULT'))
    document.querySelector(':root').style.setProperty('--primary-600', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-600'))
    document.querySelector(':root').style.setProperty('--primary-500', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-500'))
    document.querySelector(':root').style.setProperty('--primary-400', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-400'))
    document.querySelector(':root').style.setProperty('--primary-300', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-300'))
    document.querySelector(':root').style.setProperty('--primary-200', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-200'))
    document.querySelector(':root').style.setProperty('--primary-100', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-100'))
    document.querySelector(':root').style.setProperty('--primary-50', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-50'))
    document.querySelector(':root').style.setProperty('--secondary-900', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-900'))
    document.querySelector(':root').style.setProperty('--secondary-800', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-800'))
    document.querySelector(':root').style.setProperty('--secondary-DEFAULT', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-DEFAULT'))
    document.querySelector(':root').style.setProperty('--secondary-600', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-600'))
    document.querySelector(':root').style.setProperty('--secondary-500', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-500'))
    document.querySelector(':root').style.setProperty('--secondary-400', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-400'))
    document.querySelector(':root').style.setProperty('--secondary-300', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-300'))
    document.querySelector(':root').style.setProperty('--secondary-200', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-200'))
    document.querySelector(':root').style.setProperty('--secondary-100', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-100'))
    document.querySelector(':root').style.setProperty('--secondary-50', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-50'))
    document.querySelector(':root').style.setProperty('--darkblue-900', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-900'))
    document.querySelector(':root').style.setProperty('--darkblue-800', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-800'))
    document.querySelector(':root').style.setProperty('--darkblue-DEFAULT', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-DEFAULT'))
    document.querySelector(':root').style.setProperty('--darkblue-600', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-600'))
    document.querySelector(':root').style.setProperty('--darkblue-500', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-500'))
    document.querySelector(':root').style.setProperty('--darkblue-400', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-400'))
    document.querySelector(':root').style.setProperty('--darkblue-300', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-300'))
    document.querySelector(':root').style.setProperty('--darkblue-200', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-200'))
    document.querySelector(':root').style.setProperty('--darkblue-100', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-100'))
    document.querySelector(':root').style.setProperty('--darkblue-50', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-50'))

    commit('resetColors')
  },
  async getColumnsVistas ({ commit }) {
    const data = await getColumnsVistas({ version: process.env.VUE_APP_VERSION })
    if (data.blnError === true) {
      console.log(data.msgError + ' [Código de error: ' + data.codError + ']')
    } else {
      // console.log(data.respuesta)
      data.respuesta.forEach(element => {
        const columnas = element.Columnas.split(';')
        switch (element.IdVista) {
          case 1:
            commit('notifications/setKendoColumns', columnas, { root: true })
            break
          // case 3:
          //   commit('historical/setKendoColumns', columnas, { root: true })
          //   break
          case 4:
            commit('companies/setKendoColumns', columnas, { root: true })
            break
          case 5:
            commit('locations/setKendoColumns', columnas, { root: true })
            break
          case 6:
            commit('certificates/setKendoColumns', columnas, { root: true })
            break
          case 7:
            commit('certcompanies/setKendoColumns', columnas, { root: true })
            break
          case 8:
            commit('clients/setKendoColumns', columnas, { root: true })
            break
          case 9:
            commit('users/setKendoColumns', columnas, { root: true })
            break
          case 10:
            commit('userscompanies/setKendoColumns', columnas, { root: true })
            break
          case 12:
            commit('userstatus/setKendoColumns', columnas, { root: true })
            break
          case 16:
            commit('companylocations/setKendoColumns', columnas, { root: true })
            break
          case 17:
            commit('clientlocations/setKendoColumns', columnas, { root: true })
            break
          case 18:
            commit('historicalNEO/setKendoColumns', columnas, { root: true })
            break
          case 19:
            commit('historicalCompany/setKendoColumns', columnas, { root: true })
            break
          case 20:
            commit('historicalCert/setKendoColumns', columnas, { root: true })
            break
          case 21:
            commit('historicalClient/setKendoColumns', columnas, { root: true })
            break
          case 22:
            commit('historicalUser/setKendoColumns', columnas, { root: true })
            break
          case 23:
            commit('trashUsers/setKendoColumns', columnas, { root: true })
            break
          case 24:
            commit('trashHistoricalUsers/setKendoColumns', columnas, { root: true })
            break
          case 25:
            commit('trashNotifications/setKendoColumns', columnas, { root: true })
            break
          case 26:
            commit('trashHistoricalNotifications/setKendoColumns', columnas, { root: true })
            break
          case 27:
            commit('trashCompanies/setKendoColumns', columnas, { root: true })
            break
          case 28:
            commit('trashHistoricalCompanies/setKendoColumns', columnas, { root: true })
            break
          case 29:
            commit('trashCertificates/setKendoColumns', columnas, { root: true })
            break
          case 30:
            commit('trashHistoricalCertificates/setKendoColumns', columnas, { root: true })
            break
          case 40:
            commit('groups/setKendoColumns', columnas, { root: true })
            break
          case 41:
            commit('groupusers/setKendoColumns', columnas, { root: true })
            break
          case 42:
            commit('groupcompanies/setKendoColumns', columnas, { root: true })
            break
          case 43:
            commit('groupstatuses/setKendoColumns', columnas, { root: true })
            break
          case 44:
            commit('grouprules/setKendoColumns', columnas, { root: true })
            break
          case 45:
            commit('historicalGroup/setKendoColumns', columnas, { root: true })
            break
          case 46:
            commit('trashGroups/setKendoColumns', columnas, { root: true })
            break
          case 47:
            commit('trashHistoricalGroups/setKendoColumns', columnas, { root: true })
            break
          case 48:
            commit('usergroups/setKendoColumns', columnas, { root: true })
            break
          case 49:
            commit('neogroups/setKendoColumns', columnas, { root: true })
            break
          case 50:
            commit('rules/setKendoColumns', columnas, { root: true })
            break
          case 51:
            commit('rulegroups/setKendoColumns', columnas, { root: true })
            break
          case 52:
            commit('historicalRule/setKendoColumns', columnas, { root: true })
            break
          case 53:
            commit('imports/setKendoColumns', columnas, { root: true })
            break
          case 60:
            commit('groupingcompanies/setKendoColumns', columnas, { root: true })
            break
          case 61:
            commit('groupinglocations/setKendoColumns', columnas, { root: true })
            break
          case 62:
            commit('groupingagencies/setKendoColumns', columnas, { root: true })
            break
          case 71:
            commit('distributors/setKendoColumns', columnas, { root: true })
            break
          case 72:
            commit('distributorlocations/setKendoColumns', columnas, { root: true })
            break
          case 73:
            commit('historicalDistributor/setKendoColumns', columnas, { root: true })
            break
          case 80:
            commit('groupgroups/setKendoColumns', columnas, { root: true })
            break
          case 81:
            commit('configflow/setKendoColumns', columnas, { root: true })
            break
          case 82:
            commit('historicalConfigflow/setKendoColumns', columnas, { root: true })
            break
          case 83:
            commit('neopresentations/setKendoColumns', columnas, { root: true })
            break
          case 84:
            commit('documentmaster/setKendoColumns', columnas, { root: true })
            break 
          case 85:
            commit('companyothercertificates/setKendoColumns', columnas, { root: true })
            break 
          case 86:
            commit('orgprovinces/setKendoColumns', columnas, { root: true })
            break 
          case 87:
            commit('historicalOrgprovinces/setKendoColumns', columnas, { root: true })
            break 
          case 88:
            commit('apirequests/setKendoColumns', columnas, { root: true })
            break 
          case 89:
            commit('historicalAPIrequests/setKendoColumns', columnas, { root: true })
            break 
          case 90:
            commit('procedings/setKendoColumns', columnas, { root: true })
            break 
          case 91:
            commit('historicalProceding/setKendoColumns', columnas, { root: true })
            break 
          default:
            break
        }
      })
    }
  },
  updateidClienteFilterAlerts ({ commit }, payload) {
    commit('setidClienteFilterAlerts', payload)
  },
  updateidClienteFilterNav ({ commit }, payload) {
    commit('setidClienteFilterNav', payload)
  },
  updateDashboardFilterNav ({ commit, rootGetters }) {
    let payload = {
      idCliente: rootGetters['dashboard/getSelectedClient'],
      Nombre: rootGetters['dashboard/getSelectedClientName'],
    }
    if (payload.idCliente === 0 || payload.idCliente === -1) {
      payload = null
    }
    commit('setidClienteFilterAlerts', payload)
    commit('setidClienteFilterNav', payload)
  },
  updatetourFirstStepsActive ({ commit }, payload) {
    commit('settourFirstStepsActive', payload)
  },
  updateautoIdleTime ({ commit }, payload) {
    commit('setautoIdleTime', payload)
  },
  updatealertsTimeExtended ({ commit }, payload) {
    commit('setalertsTimeExtended', payload)
  },
  updatecontrolFlagLicense ({ commit }, payload) {
    commit('setcontrolFlagLicense', payload)
  },
  updatecontrolFlagWizard ({ commit }, payload) {
    commit('setcontrolFlagWizard', payload)
  },
  updatelastVisitedPatchNotes ({ commit, state }) {
    commit('setlastVisitedPatchNotes', state.version)
  },
  updateVersion ({ commit }) {
    commit('setVersion', process.env.VUE_APP_VERSION)
  },
  setopenTrash ({ commit }, payload) {
    commit('setopenTrash', payload)
  },
  settiposServicio ({ commit }, payload) {
    commit('settiposServicio', payload)
  },
  settiposPartners ({ commit }, payload) {
    commit('settiposPartners', payload)
  },
  settiposGruposVigilantes ({ commit }, payload) {
    commit('settiposGruposVigilantes', payload)
  },
  // settiposNotif ({ commit }, payload) {
  //   commit('settiposNotif', payload)
  // },
  setIsLower1024 ({ commit }, payload) {
    commit('setIsLower1024', payload)
  },
  setfromRouteName ({ commit }, value) {
    commit('setfromRouteName', value)
  },
  setActualRoute ({ commit }, value) {
    commit('setActualRoute', value)
  },
  setActualRoutePublic ({ commit }, value) {
    commit('setActualRoutePublic', value)
  },
  setheaderBreadCrumb ({ commit }, value) {
    commit('setheaderBreadCrumb', value)
  },
  showFeedback ({ commit }, options) {
    commit('setFeedback', options)
    commit('setShowingFeedback', true)

    const duration = options?.duration || process.env.VUE_APP_DEFAULT_FEEDBACK_DURATION || 3000
    setTimeout(() => {
      commit('setFeedback', {})
      commit('setShowingFeedback', false)
    }, duration)
  },
  hiddenFeedback ({ commit }) {
    commit('setFeedback', {})
    commit('setShowingFeedback', false)
  },
  async getLanguages ({ commit }) {
    const res = await getLanguagesService()
    commit('setLanguages', res)
  },
  getEmpresas ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('get_empresas_request')
      companies()
        .then(response => {
          if (response.data.blnError) {
            commit('get_empresas_error')
            return Promise.reject(response)
          }
          commit('get_empresas_success', response.data.Empresas)
          resolve(response)
        })
        .catch(err => {
          commit('get_empresas_error')
          reject(err)
        })
    })
  },
  setCifs ({ commit }, cifs) {
    commit('setCifs', cifs)
  },
  unlinkCert ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('unlink_cert_request')
      unlinkCertificate(payload)
        .then(response => {
          if (response.blnError) {
            commit('unlink_cert_error')
            return Promise.reject(response)
          }
          commit('unlink_cert_success', payload.idCIFEmpresa)
          resolve(response)
        })
        .catch(err => {
          commit('unlink_cert_error')
          reject(err)
        })
    })
  },
  getNotificationsStatus ({ commit, rootGetters }, estado) {
    return new Promise((resolve, reject) => {
      commit('get_notifs_request')
      let params = null
      const clienteAllViews = rootGetters['app/idClienteFilterNav']
      if (clienteAllViews) {
        params = {
          idCliente: clienteAllViews.idCliente
        }
      }
      getNotificationsStatus(params).then(response => {
        if (response.blnError) {
          commit('get_notifs_error')
          return Promise.reject(response)
        }
        commit('get_notifs_success', response.respuesta)
        resolve(response)
      })
        .catch(err => {
          commit('get_notifs_error')
          reject(err)
        })
    })
  },
  getNotificationsTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('get_types_request')
      getNotificationsType().then(response => {
        if (response.blnError) {
          commit('get_types_error')
          return Promise.reject(response)
        }
        commit('get_types_success', response.respuesta)
        resolve(response)
      })
        .catch(err => {
          commit('get_types_error')
          reject(err)
        })
    })
  },
  getAnnouncementsList ({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      commit('get_announcements_request')
      let params = null
      const clienteAllViews = rootGetters['app/idClienteFilterAlerts']
      if (clienteAllViews) {
        params = {
          idCliente: clienteAllViews.idCliente
        }
      }
      getAnnouncements(params).then(response => {
        if (response.blnError) {
          commit('get_announcements_error')
          return Promise.reject(response)
        }
        commit('get_announcements_success', response.ListadoAvisos)
        resolve(response)
      })
        .catch(err => {
          commit('get_announcements_error')
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
